import { Pipe, PipeTransform, inject } from '@angular/core';
import { InsuranceType } from '@moxi.gmbh/moxi-typescriptmodels';
import { TranslateService } from '@ngx-translate/core';
import { insuranceTypes } from '@shared/models';

@Pipe({
  name: 'insuranceTypeName',
  standalone: true
})
export class InsuranceTypePipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  transform(value: InsuranceType): unknown {
    const insuranceType = insuranceTypes.find(type => type.id === value)?.name;

    return insuranceType ? this.translateService.instant(insuranceType) : value;
  }
}
